import { P, FF } from "../../styles/tokens";
import { fmt } from "../../utils/format";
import { useFinancial } from "../../contexts/FinancialContext";

export default function TDCPorPagar({ compact = false }) {
  const { deudaTDC, saldoEfectivo, saldoDebito } = useFinancial();
  if (!deudaTDC.length) return null;
  const disponible = saldoEfectivo + saldoDebito;
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
      {deudaTDC.map(tdc => {
        const coberturaPct = disponible > 0 ? Math.min((disponible / tdc.totalDeuda) * 100, 100) : 0;
        const alcanza = disponible >= tdc.totalDeuda;
        return (
          <div key={tdc.id} style={{ background:"#FEF3C7", border:"1.5px solid #F59E0B", borderRadius:16, padding:compact?"14px 16px":"18px 20px" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontSize:18 }}>💳</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:800, color:"#92400E", fontFamily:FF }}>{tdc.nombre}{tdc.banco ? ` · ${tdc.banco}` : ""}</div>
                  {tdc.fechaLimitePago && <div style={{ fontSize:10, color:"#B45309", fontWeight:600 }}>Pagar antes del día {tdc.fechaLimitePago}</div>}
                  <div style={{ fontSize:10, color:"#B45309", fontFamily:FF, marginTop:2 }}>
                    {tdc.nGastos} gasto{tdc.nGastos!==1?"s":""}{tdc.nMsi > 0 ? ` + ${tdc.nMsi} MSI` : ""}
                  </div>
                </div>
              </div>
              <div style={{ fontSize:compact?18:22, fontWeight:900, color:"#92400E", fontFamily:FF }}>
                {fmt(tdc.totalDeuda)}
              </div>
            </div>
            {!compact && (
              <div style={{ marginTop:10 }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                  <span style={{ fontSize:10, fontWeight:600, color:"#92400E", fontFamily:FF }}>
                    Cobertura con efectivo + débito
                  </span>
                  <span style={{ fontSize:10, fontWeight:800, color: alcanza ? "#15803D" : "#DC2626", fontFamily:FF }}>
                    {coberturaPct.toFixed(0)}%
                  </span>
                </div>
                <div style={{ height:6, background:"rgba(146,64,14,0.15)", borderRadius:99, overflow:"hidden" }}>
                  <div style={{ height:"100%", borderRadius:99, background: alcanza ? "#22C55E" : coberturaPct > 50 ? "#F59E0B" : "#EF4444", width:`${coberturaPct}%`, transition:"width .5s ease" }} />
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", marginTop:4 }}>
                  <span style={{ fontSize:9, color:"#B45309", fontFamily:FF }}>Disponible: {fmt(disponible)}</span>
                  {!alcanza && <span style={{ fontSize:9, fontWeight:700, color:"#DC2626", fontFamily:FF }}>Faltante: {fmt(tdc.totalDeuda - disponible)}</span>}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
